import {fetch} from "utils/dataAccess";

export async function deleteCorner(id) {
    await fetch('/corners/' + id + '/delete', {
        method: "POST",
    });
}
